
export class ConvenioProyectos {
  IdConvenio: number=-1;
  IdProyecto: number =-1;
  Convenio: number = -1;
  Algoritmo:number = -1;
  IdUsuarioUM:number = -1;
  NombreConvenio:string ="";
  NombreAlgoritmo:string ="";
  Codigo:string = "";
  IdMovimiento:number= -1;
  Referencia:string ="";

}
